module.exports = __webpack_public_path__ + "img/nivel_luz_blue.9b371e28.svg";